<template>
  <div class="dom-button-group">
    <Button
      v-tooltip.bottom="
        $t('trade.dom.buy-market-tooltip', { count: quantity, unit })
      "
      class="buy"
      :disabled="!isTradable"
      @click="tradeStock('buy', isTradable)"
    >
      {{ $t('trade.dom.buy-market') }}
      <BtnCornerTag v-if="isVirtual" :tag-name="$t('settings.virtual-tag')" />
    </Button>
    <Button
      v-tooltip.bottom="
        $t('trade.dom.sell-market-tooltip', { count: quantity, unit })
      "
      class="sell"
      :disabled="!isTradable"
      @click="tradeStock('sell', isTradable)"
    >
      {{ $t('trade.dom.sell-market') }}
      <BtnCornerTag v-if="isVirtual" :tag-name="$t('settings.virtual-tag')" />
    </Button>
    <Button
      v-tooltip.bottom="$t('trade.dom.flatten-tooltip')"
      class="closeout"
      :disabled="!isCanCloseout"
      @click="tradeStock('closeout', isCanCloseout)"
    >
      {{ $t('trade.dom.flatten') }}
      <BtnCornerTag v-if="isVirtual" :tag-name="$t('settings.virtual-tag')" />
    </Button>
  </div>
</template>
<script>
import Button from 'com/Button'
import BtnCornerTag from 'mod/BtnCornerTag'
import { mapGetters } from 'vuex'
import stockMixin from 'mixins/stockMixin'
import { ORDER_TYPE } from 'const/trade'
export default {
  name: 'FunButtons',
  components: {
    Button,
    BtnCornerTag
  },
  mixins: [stockMixin],
  props: {
    stock: Object,
    isTradable: Boolean,
    positionNum: Number,
    quantity: [Number, String]
  },
  computed: {
    ...mapGetters(['isVirtual']),
    // 可平仓
    isCanCloseout() {
      return Math.abs(this.positionNum) > 0 && this.isTradable
    },
    unit() {
      if (this.quantity > 1) {
        if (this.isOPT) {
          return this.$t('trade.option-plural-unit')
        }
        return this.$t('trade.plural-unit')
      } else {
        if (this.isOPT) {
          return this.$t('trade.option-unit')
        }
        return this.$t('trade.unit')
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    tradeStock(type, isTradable) {
      if (!isTradable) return
      const data = {
        isCloseout: false,
        orderType: ORDER_TYPE.MKT
      }
      if (type === 'buy') {
        data.action = 'BUY'
      } else if (type === 'sell') {
        data.action = 'SELL'
      } else if (type === 'closeout') {
        data.isCloseout = true
        data.action = this.positionNum > 0 ? 'SELL' : 'BUY'
        data.position = Math.abs(this.positionNum)
      }
      this.$emit('tradeStock', data)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.dom-button-group {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 10px;
  .tt-button {
    position: relative;
    flex: 1;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  .buy:not(:disabled) {
    background-color: #ff6825;
  }
  .sell:not(:disabled) {
    background-color: #218df2;
  }
  .closeout:not(:disabled) {
    background-color: #616a79;
  }
}
</style>
